module.exports = __webpack_public_path__ + "static/media/tape.2bd37579.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/tape.jpg
// module id = 238
// module chunks = 0